module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9252-1-p-1080-5c97af98eb276e056229df0a318cc61a.jpeg";